import { createPostChannel } from "@src/utils/apis/requestRX";
import { Fetch, ResponseData } from "@src/utils/apis/typeRX";

export const fileValidation: Fetch<FormData, ResponseData<string>> = createPostChannel("/api/reexuan-blockchain-service/explorer/file/verify");

